import { SVGProps } from 'react';
import { ReactComponent } from 'icons/search.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
export const SearchIcon = (props: Props) => {
  return <ReactComponent className="merc-icon-search" {...props} />;
};
